//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "repayDetailList",
    props: {
        repayInitData: {
            type: Object,
        },
    },
    computed: {
        discountInfo() {
            const {
                repayShowPrincipal,
                repayShowInterestFee,
            } = this.repayInitData;

            return {
                principal: {
                    text: "还款本金",
                    amount: repayShowPrincipal,
                    isShow: repayShowPrincipal > 0,
                },
                interestFee: {
                    text: "待还息费（包含罚息）",
                    amount: repayShowInterestFee,
                    isShow: repayShowInterestFee > 0,
                }
            };
        }
    },
};
